import { Col, Row, } from "antd";
import CreditForm from "./Components/CreditForm";
import PageTitle from "apps/Common/PageTitle";





const CreditIndex = () => {



  return (
    <>
      <Col xs={24} className="!pl-0">
        <Row gutter={[0, 0]} className="">

          <Col span={24} className="!flex justify-start">
            <PageTitle
              title="Kredi Teklifleri"
            />

          </Col>
          <Col xs={24}  className="">
            <CreditForm />
          </Col>


        </Row>
      </Col>
      <></>
    </>
  );
};

export default CreditIndex;
